/**
 * Created by christiancueni on 02/08/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { CustomAction } from './CustomAction';

import {Group, User, NewGroup } from '../models';
import { type } from '../shared/util';

export const GroupsActionTypes = {
    LOAD_GROUPS: type("[Groups] Load"),
    LOAD_GROUPS_FAIL: type("[Groups] Load failed"),
    LOAD_GROUPS_SUCCESS: type("[Groups] Load success"),
    LOAD_GROUP: type("[Group] Load"),
    LOAD_GROUP_FAIL: type("[Group] Load failed"),
    LOAD_GROUP_SUCCESS: type("[Group] Load success"),
    LOAD_GROUPS_FOR_SCHOOL: type("[Groups for School] Load"),
    LOAD_GROUPS_FOR_SCHOOL_FAIL: type("[Groups for School] Load failed"),
    LOAD_GROUPS_FOR_SCHOOL_SUCCESS: type("[Groups for School] Load success"),
    LOAD_GROUP_MEMBERS: type("[Groups] Load members"),
    LOAD_GROUP_MEMBERS_FAIL: type("[Groups] Load members failed"),
    LOAD_GROUP_MEMBERS_SUCCESS: type("[Groups] Load members success"),
    ADD_GROUP: type("[Groups] Add"),
    ADD_GROUP_FAIL: type("[Groups] Add failed"),
    ADD_GROUP_SUCCESS: type("[Groups] Add success"),
    UPDATE_GROUP: type("[Groups] Update"),
    UPDATE_GROUP_FAIL: type("[Groups] Update failed"),
    UPDATE_GROUP_SUCCESS: type("[Groups] Update success"),
    DELETE_GROUP_USER_ACTION: type("[Groups] Delete user action"),
    DELETE_GROUP_CONFIRMATION: type("[Groups] Delete confirmation"),
    DELETE_GROUP_CANCEL: type("[Groups] Delete cancel"),
    DELETE_GROUP: type("[Groups] Delete"),
    DELETE_GROUP_SUCCESS: type("[Groups] Delete success"),
    DELETE_GROUP_FAIL: type("[Groups] Delete fail"),
    ADD_MEMBERS_TO_GROUP: type("[Groups] Add members"),
    ADD_MEMBERS_TO_GROUP_SUCCESS: type("[Groups] Add members success"),
    ADD_MEMBERS_TO_GROUP_FAIL: type("[Groups] Add members fail"),
    REMOVE_MEMBERS_FROM_GROUP: type("[Groups] Remove members"),
    REMOVE_MEMBERS_FROM_GROUP_SUCCESS: type("[Groups] Remove members success"),
    REMOVE_MEMBERS_FROM_GROUP_FAIL: type("[Groups] Remove members fail"),
    SET_GROUP: type("[Groups] set"),
    UNSET_GROUP: type("[Groups] unset"),
    SHOW_REMOVE_USER_ACTION: type("[Groups] Show user action"),
    HIDE_REMOVE_USER_ACTION: type("[Groups] Hide user action"),
    SHOW_REMOVE_USER_MODAL: type('[Groups] Show user remove modal'),
    HIDE_REMOVE_USER_MODAL: type('[Groups] Hide user remove modal'),
    SHOW_DELETE_USER_MODAL: type('[Groups] Show user delete modal'),
    HIDE_DELETE_USER_MODAL: type('[Groups] Hide user delete modal'),
    GROUPS_FORM_ERRORS: type('[Groups] Groups Form Errors'),
    GENERATE_ACTIVATION_LINKS: type('[Groups] Generate Activation Links'),
    GENERATE_ACTIVATION_LINKS_SUCCESS: type('[Groups] Generate Activation Links Success'),
    GENERATE_ACTIVATION_LINKS_FAIL: type('[Groups] Generate Activation Links Fail'),
    RESET_GROUPS: type('[Groups] Reset groups')
};

export class LoadGroupsAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUPS;

    constructor() {}
}

export class LoadGroupsFailAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUPS_FAIL;

    constructor(public payload: string) {}
}

export class LoadGroupsSuccessAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUPS_SUCCESS;

    constructor(public payload: Group[]) {}
}

export class LoadGroupAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUP;

    constructor(public payload: string) {}
}

export class LoadGroupFailAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUP_FAIL;

    constructor(public payload: string) {}
}

export class LoadGroupSuccessAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUP_SUCCESS;

    constructor(public payload: Group) {}
}

export class LoadGroupsForSchoolAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUPS_FOR_SCHOOL;

    constructor() {}
}

export class LoadGroupsForSchoolFailAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUPS_FOR_SCHOOL_FAIL;

    constructor(public payload: string) {}
}

export class LoadGroupsForSchoolSuccessAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUPS_FOR_SCHOOL_SUCCESS;

    constructor(public payload: Group[]) {}
}

export class LoadGroupsMembersAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUP_MEMBERS;

    constructor(public payload: number) {}
}

export class LoadGroupsMembersFailAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUP_MEMBERS_FAIL;

    constructor(public payload: string) {}
}

export class LoadGroupsMembersSuccessAction implements CustomAction {
    type = GroupsActionTypes.LOAD_GROUP_MEMBERS_SUCCESS;

    constructor(public payload: User[]) {}
}

export class DeleteGroupUserAction implements CustomAction {
    type = GroupsActionTypes.DELETE_GROUP_USER_ACTION;

    constructor(public payload: Object) {}
}

export class DeleteGroupConfirmationAction implements CustomAction {
    type = GroupsActionTypes.DELETE_GROUP_CONFIRMATION;

    constructor(public payload: number) {}
}

export class DeleteGroupCancelAction implements CustomAction {
    type = GroupsActionTypes.DELETE_GROUP_CANCEL;

    constructor() {}
}

export class DeleteGroupAction implements CustomAction {
    type = GroupsActionTypes.DELETE_GROUP;

    constructor(public payload: number) {}
}

export class DeleteGroupSuccessAction implements CustomAction {
    type = GroupsActionTypes.DELETE_GROUP_SUCCESS;

    constructor(public payload: Group) {}
}

export class DeleteGroupFailAction implements CustomAction {
    type = GroupsActionTypes.DELETE_GROUP_FAIL;

    constructor(public payload: string) {}
}

export class AddGroupAction implements CustomAction {
    type = GroupsActionTypes.ADD_GROUP;

    constructor(public payload: NewGroup) {}
}

export class AddGroupFailAction implements CustomAction {
    type = GroupsActionTypes.ADD_GROUP_FAIL;

    constructor(public payload: string) {}
}

export class AddGroupSuccessAction implements CustomAction {
    type = GroupsActionTypes.ADD_GROUP_SUCCESS;

    constructor(public payload: Group) {}
}

export class UpdateGroupAction implements CustomAction {
    type = GroupsActionTypes.UPDATE_GROUP;

    constructor(public payload: NewGroup) {}
}

export class UpdateGroupFailAction implements CustomAction {
    type = GroupsActionTypes.UPDATE_GROUP_FAIL;

    constructor(public payload: string) {}
}

export class UpdateGroupSuccessAction implements CustomAction {
    type = GroupsActionTypes.UPDATE_GROUP_SUCCESS;

    constructor(public payload: Group) {}
}

export class AddMembersToGroupAction implements CustomAction {
    type = GroupsActionTypes.ADD_MEMBERS_TO_GROUP;

    constructor(public payload: Object[]) {}
}

export class AddMembersToGroupFailAction implements CustomAction {
    type = GroupsActionTypes.ADD_MEMBERS_TO_GROUP_FAIL;

    constructor(public payload: string) {}
}

export class AddMembersToGroupSuccessAction implements CustomAction {
    type = GroupsActionTypes.ADD_MEMBERS_TO_GROUP_SUCCESS;

    constructor() {}
}

export class RemoveMembersFromGroupAction implements CustomAction {
    type = GroupsActionTypes.REMOVE_MEMBERS_FROM_GROUP;

    constructor(public payload: Object[]) {}
}

export class RemoveMembersFromGroupFailAction implements CustomAction {
    type = GroupsActionTypes.REMOVE_MEMBERS_FROM_GROUP_FAIL;

    constructor(public payload: string) {}
}

export class RemoveMembersFromGroupSuccessAction implements CustomAction {
    type = GroupsActionTypes.REMOVE_MEMBERS_FROM_GROUP_SUCCESS;

    constructor() {}
}

export class SetGroupAction implements CustomAction {
    type = GroupsActionTypes.SET_GROUP;

    constructor(public payload: number) {}
}

export class UnsetGroupAction implements CustomAction {
    type = GroupsActionTypes.UNSET_GROUP;

    constructor() {}
}

export class ShowRemoveUserAction implements CustomAction {
    type = GroupsActionTypes.SHOW_REMOVE_USER_ACTION;

    constructor() {}
}

export class HideRemoveUserAction implements CustomAction {
    type = GroupsActionTypes.HIDE_REMOVE_USER_ACTION;

    constructor() {}
}

export class ShowRemoveUserModalAction implements CustomAction {
    type = GroupsActionTypes.SHOW_REMOVE_USER_MODAL;

    constructor() {}
}

export class HideRemoveUserModalAction implements CustomAction {
    type = GroupsActionTypes.HIDE_REMOVE_USER_MODAL;

    constructor() {}
}

export class UpdateGroupsFormErrorsAction implements CustomAction {
    type = GroupsActionTypes.GROUPS_FORM_ERRORS;

    constructor(public payload: Object) {}
}

export class HideDeleteUserAction implements CustomAction {
    type = GroupsActionTypes.HIDE_DELETE_USER_MODAL;

    constructor() {}
}

export class ShowDeleteUserModalAction implements CustomAction {
    type = GroupsActionTypes.SHOW_DELETE_USER_MODAL;

    constructor() {}
}

export class GenerateActivationLinksAction implements CustomAction {
    type = GroupsActionTypes.GENERATE_ACTIVATION_LINKS;

    constructor(public payload: Object[]) {}
}

export class GenerateActivationLinksSuccessAction implements CustomAction {
    type = GroupsActionTypes.GENERATE_ACTIVATION_LINKS_SUCCESS;

    constructor() {}
}

export class GenerateActivationLinksFailAction implements CustomAction {
    type = GroupsActionTypes.GENERATE_ACTIVATION_LINKS_FAIL;

    constructor(public payload: Object) {}
}

export class ResetGroupsAction implements CustomAction {
    type = GroupsActionTypes.RESET_GROUPS;

    constructor() {}
}

export type GroupActions =
    LoadGroupsAction
        | LoadGroupsFailAction
        | LoadGroupsSuccessAction
        | LoadGroupsMembersAction
        | LoadGroupsMembersFailAction
        | LoadGroupsMembersSuccessAction
        | AddGroupAction
        | AddGroupFailAction
        | AddGroupSuccessAction
        | RemoveMembersFromGroupAction
        | RemoveMembersFromGroupFailAction
        | RemoveMembersFromGroupSuccessAction
        | DeleteGroupUserAction
        | DeleteGroupConfirmationAction
        | DeleteGroupCancelAction
        | DeleteGroupAction
        | DeleteGroupSuccessAction
        | DeleteGroupFailAction
        | AddMembersToGroupAction
        | AddMembersToGroupSuccessAction
        | AddMembersToGroupFailAction
        | SetGroupAction
        | UnsetGroupAction
        | HideRemoveUserAction
        | ShowRemoveUserAction
        | ShowRemoveUserModalAction
        | HideRemoveUserModalAction
        | ShowDeleteUserModalAction
        | HideDeleteUserAction
        | LoadGroupAction
        | LoadGroupFailAction
        | LoadGroupSuccessAction
        | UpdateGroupsFormErrorsAction
        | GenerateActivationLinksAction
        | GenerateActivationLinksSuccessAction
        | GenerateActivationLinksFailAction
        | ResetGroupsAction;

